// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Popover-Menu {
  font-weight: 600;
  padding: 0 3rem;
}
.Popover-Menu .popover-header {
  border-radius: var(--bs-border-radius) var(--bs-border-radius) 0rem 0rem;
  background: transparent;
  border-bottom: 1px solid var(--bs-primary);
}
.Popover-Menu .popover-body {
  --bs-popover-body-padding-x: 0;
}
.Popover-Menu {
  --bs-popover-border-width: 0.25rem;
  --bs-popover-border-color: var(--bs-primary);
}`, "",{"version":3,"sources":["webpack://./src/components/EditPopover/styles.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,eAAA;AACF;AAAE;EACE,wEAAA;EACA,uBAAA;EACA,0CAAA;AAEJ;AAAE;EAEE,8BAAA;AACJ;AAXA;EAYE,kCAAA;EACA,4CAAA;AAEF","sourcesContent":[".Popover-Menu {\n  font-weight: 600;\n  padding: 0 3rem;\n  .popover-header {\n    border-radius: var(--bs-border-radius) var(--bs-border-radius) 0rem 0rem;\n    background: transparent;\n    border-bottom: 1px solid var(--bs-primary);\n  }\n  .popover-body {\n    // Popovers\n    --bs-popover-body-padding-x: 0;\n  }\n  --bs-popover-border-width: 0.25rem;\n  --bs-popover-border-color: var(--bs-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
